import { isSameDay, parseISO, startOfDay } from 'date-fns';

import type { ApiISODateTimeString } from '#/api/types/ApiTypedDate';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { shorterDate, shorterTime } from '#/utils/date';

type Args = {
  locale: I18nLocale;
  startDateTime?: ApiISODateTimeString | null;
  endDateTime?: ApiISODateTimeString | null;
  timezone?: string | null;
};

export function formatSearchHitDate({
  locale,
  startDateTime,
  endDateTime,
  timezone,
}: Args) {
  // 1/12/2024 - 4/02/2025
  if (
    startDateTime &&
    endDateTime &&
    !isSameDay(endDateTime, startDateTime) &&
    startOfDay(startDateTime).getTime() === parseISO(startDateTime).getTime() &&
    startOfDay(endDateTime).getTime() === parseISO(endDateTime).getTime()
  ) {
    return `${shorterDate({ date: startDateTime, locale })} - ${shorterDate({ date: endDateTime, locale })}`;
  }

  // 1/12/2024 10:00 AM - 5:00 PM EDT
  if (startDateTime && endDateTime && isSameDay(endDateTime, startDateTime)) {
    return `${shorterDate({ date: startDateTime, locale })} ${shorterTime({ date: startDateTime, timezone, displayTimezone: false, locale })} - ${shorterTime({ date: endDateTime, timezone, displayTimezone: true, locale })}`;
  }

  // 1/12/2024 10:00 AM - 4/02/2025 5:00 PM EDT
  if (startDateTime && endDateTime) {
    return `${shorterDate({ date: startDateTime, locale })} ${shorterTime({ date: startDateTime, timezone, displayTimezone: false, locale })} - ${shorterDate({ date: endDateTime, locale })} ${shorterTime({ date: endDateTime, timezone, displayTimezone: true, locale })}`;
  }

  // 1/12/2024 10:00 AM EDT
  if (startDateTime && !endDateTime) {
    return `${shorterDate({ date: startDateTime, locale })} ${shorterTime({ date: startDateTime, timezone, displayTimezone: true, locale })}`;
  }
}
